// Pipeline de 6 macro-etapas — Viaje del Paciente UC Christus
// Derivado de funnelAmbulatorio y datos reales Abril 2026

export const PIPELINE_STAGES = [
  {
    id: 1,
    key: "acceso",
    nombre: "Acceso",
    icono: "Hospital",
    color: "#7C3AED",
    volumen: 128574,
    conversion_anterior: 100,
    delta_periodo: null,
    sub_etapas: [
      { nombre: "Búsqueda web", pacientes: 208221, fuente: "Athena clickstream", estado: "REAL" },
      { nombre: "Login / identificación", pacientes: 147522, fuente: "Athena", estado: "REAL" },
      { nombre: "Selección hora", pacientes: 143024, fuente: "Athena", estado: "REAL" },
      { nombre: "Confirmación", pacientes: 128574, fuente: "Athena", estado: "REAL" },
    ],
    quiebres: [
      { descripcion: "29.1% abandona entre búsqueda e identificación (60.699 pacientes)", porcentaje: 29.1, motivo: "No encontró hora o error en búsqueda (92K errores caja)", severidad: "alta" },
      { descripcion: "10.1% abandona entre selección y confirmación (14.450 pacientes)", porcentaje: 10.1, motivo: "Abandono antes de confirmar", severidad: "media" },
      { descripcion: "3.0% abandona entre identificación y selección (4.498 pacientes)", porcentaje: 3.0, motivo: "No encontró hora disponible", severidad: "baja" },
    ],
    acciones: [
      { icono: "Search", titulo: "Optimizar buscador web", descripcion: "Reducir errores de caja de búsqueda (92K errores detectados)" },
      { icono: "Clock", titulo: "Ampliar oferta horaria", descripcion: "Aumentar disponibilidad en horarios peak para reducir abandono" },
      { icono: "MessageCircle", titulo: "Recuperación por WhatsApp", descripcion: "Contactar pacientes que abandonaron antes de confirmar" },
    ],
  },
  {
    id: 2,
    key: "atencion",
    nombre: "Atención",
    icono: "Stethoscope",
    color: "#3B82F6",
    volumen: 123336,
    conversion_anterior: 95.9,
    delta_periodo: null,
    sub_etapas: [
      { nombre: "Agendamiento PRM", pacientes: 117686, fuente: "PRM Redshift", estado: "REAL" },
      { nombre: "Consulta médica", pacientes: 123336, fuente: "DG ambulatorio", estado: "REAL" },
      { nombre: "Telemedicina", pacientes: 9048, fuente: "DG ambulatorio", estado: "REAL" },
      { nombre: "Registro clínico", pacientes: null, fuente: "TrakCare", estado: "PENDIENTE" },
    ],
    quiebres: [
      { descripcion: "37.3% cancelaciones PRM (70.844 citas)", porcentaje: 37.3, motivo: "Voluntad paciente 74%, funcionario 17%", severidad: "alta" },
      { descripcion: "12.1% no-show (14.418 pacientes)", porcentaje: 12.1, motivo: "No llegó a la cita vigente", severidad: "alta" },
      { descripcion: "Telemedicina solo 7.3% del total de consultas", porcentaje: 7.3, motivo: "Baja adopción de canal digital", severidad: "media" },
    ],
    acciones: [
      { icono: "Phone", titulo: "Confirmación proactiva", descripcion: "Llamada/WhatsApp 48h antes para reducir no-show (12.1%)" },
      { icono: "XCircle", titulo: "Análisis de cancelaciones", descripcion: "Investigar motivos del 74% cancelación por voluntad paciente" },
      { icono: "Monitor", titulo: "Promover telemedicina", descripcion: "Aumentar adopción de telemedicina desde 7.3% actual" },
    ],
  },
  {
    id: 3,
    key: "diagnostica",
    nombre: "Resolución Diagnóstica",
    icono: "FlaskConical",
    color: "#14B8A6",
    volumen: 63212,
    conversion_anterior: 51.3,
    delta_periodo: null,
    sub_etapas: [
      { nombre: "Laboratorio indicado → realizado", pacientes: 63212, fuente: "Modulab x org_indicaciones", estado: "REAL", conversion: 42.2 },
      { nombre: "Imagenología indicada → realizada", pacientes: 46298, fuente: "AGFA x org_indicaciones", estado: "REAL", conversion: 36.5 },
      { nombre: "Resultados entregados", pacientes: null, fuente: "Pendiente", estado: "PENDIENTE" },
    ],
    quiebres: [
      { descripcion: "57.8% lab indicado no realizado en 6 meses (86.480 pacientes)", porcentaje: 57.8, motivo: "Lab indicado no realizado en 6 meses", severidad: "alta" },
      { descripcion: "63.5% imagen indicada no realizada en 6 meses (80.428 pacientes)", porcentaje: 63.5, motivo: "Imagen indicada no realizada en 6 meses", severidad: "alta" },
      { descripcion: "Resultados sin trazabilidad end-to-end", porcentaje: null, motivo: "No hay integración de entrega de resultados", severidad: "media" },
    ],
    acciones: [
      { icono: "Bell", titulo: "Alertas de indicaciones pendientes", descripcion: "Notificar pacientes con lab/imagen indicada no realizada >30 días" },
      { icono: "Calendar", titulo: "Agendamiento automático", descripcion: "Agendar lab/imagen automáticamente al momento de la indicación" },
      { icono: "BarChart3", titulo: "Dashboard de realización", descripcion: "Monitoreo en tiempo real de tasas de realización por centro" },
    ],
  },
  {
    id: 4,
    key: "tratamiento",
    nombre: "Tratamiento",
    icono: "Pill",
    color: "#F59E0B",
    volumen: 61089,
    conversion_anterior: 96.6,
    delta_periodo: null,
    sub_etapas: [
      { nombre: "Indicación médica", pacientes: 61089, fuente: "org_indicaciones", estado: "REAL" },
      { nombre: "Farmacia dispensación", pacientes: null, fuente: "SAP mb51", estado: "MOCK" },
      { nombre: "Entrega medicamento", pacientes: null, fuente: "SAP mb51", estado: "MOCK" },
      { nombre: "Cirugía", pacientes: 7195, fuente: "SAP Pabellón", estado: "REAL" },
    ],
    quiebres: [
      { descripcion: "17.8% pacientes perdidos en CRM quirúrgico (2.925)", porcentaje: 17.8, motivo: "Paciente perdido en CRM quirúrgico", severidad: "alta" },
      { descripcion: "8.5% tasa de devolución de medicamentos", porcentaje: 8.5, motivo: "Devolución de medicamentos dispensados", severidad: "media" },
      { descripcion: "Dispensación sin trazabilidad completa", porcentaje: null, motivo: "Falta integración SAP-TrakCare para dispensación", severidad: "baja" },
    ],
    acciones: [
      { icono: "UserCheck", titulo: "Seguimiento CRM quirúrgico", descripcion: "Contactar 2.925 pacientes perdidos en CRM Keiron" },
      { icono: "Package", titulo: "Reducir devoluciones", descripcion: "Analizar top medicamentos devueltos y optimizar prescripción" },
      { icono: "Link", titulo: "Integrar dispensación", descripcion: "Conectar SAP mb51 con TrakCare para trazabilidad completa" },
    ],
  },
  {
    id: 5,
    key: "financiero",
    nombre: "Financiero",
    icono: "DollarSign",
    color: "#EC4899",
    volumen: 138986,
    conversion_anterior: 100,
    delta_periodo: null,
    sub_etapas: [
      { nombre: "Bono IMED", pacientes: 138986, fuente: "com_zimed_report", estado: "REAL" },
      { nombre: "Pago / copago", pacientes: null, fuente: "SAP", estado: "MOCK" },
      { nombre: "Facturación", pacientes: null, fuente: "SAP", estado: "MOCK" },
    ],
    quiebres: [
      { descripcion: "Bonos IMED sin cruce con copago real", porcentaje: null, motivo: "Falta integración SAP para copago", severidad: "media" },
      { descripcion: "Facturación sin trazabilidad paciente", porcentaje: null, motivo: "SAP no cruza por RUT de paciente", severidad: "media" },
      { descripcion: "Sin datos de rechazo de bonos", porcentaje: null, motivo: "IMED no reporta rechazos en el feed actual", severidad: "baja" },
    ],
    acciones: [
      { icono: "CreditCard", titulo: "Integrar copago SAP", descripcion: "Cruzar bonos IMED con pagos SAP por episodio" },
      { icono: "FileText", titulo: "Trazabilidad facturación", descripcion: "Agregar RUT paciente al flujo de facturación SAP" },
      { icono: "AlertTriangle", titulo: "Monitorear rechazos", descripcion: "Implementar feed de rechazos IMED para alertas" },
    ],
  },
  {
    id: 6,
    key: "seguimiento",
    nombre: "Seguimiento",
    icono: "RefreshCw",
    color: "#6366F1",
    volumen: null,
    conversion_anterior: null,
    delta_periodo: null,
    sub_etapas: [
      { nombre: "Controles post-atención", pacientes: null, fuente: "Pendiente", estado: "MOCK" },
      { nombre: "CRM contacto proactivo", pacientes: null, fuente: "Salesforce", estado: "MOCK" },
      { nombre: "Re-agendamiento", pacientes: null, fuente: "PRM", estado: "MOCK" },
    ],
    quiebres: [
      { descripcion: "Solo 19% de pacientes vuelve a control", porcentaje: 19.0, motivo: "Baja tasa de retorno a control post-atención", severidad: "alta" },
      { descripcion: "26.7% tasa de respuesta a encuestas", porcentaje: 26.7, motivo: "Baja participación en encuestas NPS", severidad: "media" },
      { descripcion: "Sin datos reales de seguimiento", porcentaje: null, motivo: "Etapa pendiente de integración", severidad: "baja" },
    ],
    acciones: [
      { icono: "CalendarCheck", titulo: "Agendar control automático", descripcion: "Crear cita de control al momento del alta" },
      { icono: "MessageSquare", titulo: "Encuesta post-atención", descripcion: "Enviar encuesta NPS por WhatsApp dentro de 24h" },
      { icono: "Database", titulo: "Integrar fuentes", descripcion: "Conectar Salesforce CRM y PRM para datos reales de seguimiento" },
    ],
  },
];

// Transiciones entre macro-etapas (para Panel_Fugas)
export const PIPELINE_TRANSICIONES = [
  { desde: "Acceso", hacia: "Atención", perdidos: 5238, pct_perdida: 4.1 },
  { desde: "Atención", hacia: "Diagnóstica", perdidos: 60124, pct_perdida: 48.7 },
  { desde: "Diagnóstica", hacia: "Tratamiento", perdidos: 2123, pct_perdida: 3.4 },
  { desde: "Tratamiento", hacia: "Financiero", perdidos: null, pct_perdida: null },
  { desde: "Financiero", hacia: "Seguimiento", perdidos: null, pct_perdida: null },
];

// Evolución de conversión global (para Panel_Evolución)
// DATOS REALES — Calculados desde PRM (citas) y DG (consultas realizadas)
// Conversión = consultas DG / citas PRM × 100
export const PIPELINE_EVOLUCION = [
  { mes: "May 2025", conversion: 60.8 },  // 115046/189199
  { mes: "Jun 2025", conversion: 59.8 },  // 113476/189719
  { mes: "Jul 2025", conversion: 61.8 },  // 127749/206810
  { mes: "Ago 2025", conversion: 60.3 },  // 120002/199141
  { mes: "Sep 2025", conversion: 60.2 },  // 114119/189462
  { mes: "Oct 2025", conversion: 60.8 },  // 130445/214539
  { mes: "Nov 2025", conversion: 60.7 },  // 116789/192405
  { mes: "Dic 2025", conversion: 62.8 },  // 112895/179836
  { mes: "Ene 2026", conversion: 61.6 },  // 115307/187193
  { mes: "Feb 2026", conversion: 59.2 },  // 87681/148216
  { mes: "Mar 2026", conversion: 63.5 },  // 131054/206537
  { mes: "Abr 2026", conversion: 74.7 },  // 123718/165646
];

/**
 * Determina el Punto Crítico: la macro-etapa con mayor fuga acumulada.
 * @param {Array} stages - Array de macro-etapas con quiebres
 * @returns {number|null} id de la macro-etapa con mayor fuga
 */
export function getPuntoCritico(stages) {
  let maxFuga = 0;
  let critico = null;
  for (const stage of stages) {
    const fugaTotal = stage.quiebres
      .filter((q) => q.porcentaje != null)
      .reduce((sum, q) => sum + q.porcentaje, 0);
    if (fugaTotal > maxFuga) {
      maxFuga = fugaTotal;
      critico = stage.id;
    }
  }
  return critico;
}

/**
 * Determina el estado predominante (peor) de un array de sub-etapas.
 * Prioridad: PENDIENTE (peor) > MOCK > SIMULADO > REAL (mejor)
 * @param {Array} subEtapas - Array de sub-etapas con campo estado
 * @returns {string} Estado predominante
 */
export function getEstadoPredominante(subEtapas) {
  const prioridad = { PENDIENTE: 0, MOCK: 1, SIMULADO: 2, REAL: 3 };
  let peor = 3;
  for (const sub of subEtapas) {
    const p = prioridad[sub.estado] ?? 3;
    if (p < peor) peor = p;
  }
  const reverso = { 0: "PENDIENTE", 1: "MOCK", 2: "SIMULADO", 3: "REAL" };
  return reverso[peor];
}

// ============================================================
// Pipelines por tipo de viaje (Hospitalario, Oncológico, Diálisis, Urgencia)
// ============================================================

export const PIPELINE_HOSPITALARIO = [
  {
    id: 1, key: "indicacion", nombre: "Indicación Quirúrgica", icono: "Stethoscope", color: "#14B8A6",
    volumen: 16431, conversion_anterior: 100, delta_periodo: null,
    sub_etapas: [
      { nombre: "Indicación de cirugía", pacientes: 16431, fuente: "org_indicaciones", estado: "REAL" },
    ],
    quiebres: [
      { descripcion: "2% no llega al CRM (332 pacientes)", porcentaje: 2.0, motivo: "No llegan al CRM Keiron", severidad: "baja" },
    ],
    acciones: [
      { icono: "Link", titulo: "Integrar indicación → CRM", descripcion: "Automatizar ingreso de indicaciones quirúrgicas al CRM" },
      { icono: "Bell", titulo: "Alerta de indicación sin CRM", descripcion: "Notificar cuando una indicación no tiene registro en Keiron" },
      { icono: "Database", titulo: "Auditar flujo", descripcion: "Revisar los 332 pacientes que no llegan al CRM" },
    ],
  },
  {
    id: 2, key: "crm", nombre: "CRM Quirúrgico", icono: "Hospital", color: "#84CC16",
    volumen: 16099, conversion_anterior: 98.0, delta_periodo: null,
    sub_etapas: [
      { nombre: "En CRM Keiron", pacientes: 16099, fuente: "Keiron CRM v2", estado: "REAL" },
      { nombre: "En seguimiento", pacientes: 9562, fuente: "Keiron CRM v2", estado: "REAL" },
      { nombre: "Presupuesto entregado", pacientes: 6989, fuente: "Keiron CRM v2", estado: "REAL" },
    ],
    quiebres: [
      { descripcion: "17.8% pacientes perdidos (2.925)", porcentaje: 17.8, motivo: "No convierte presupuesto", severidad: "alta" },
      { descripcion: "2.3% incontactable (384)", porcentaje: 2.3, motivo: "No se pudo contactar", severidad: "media" },
    ],
    acciones: [
      { icono: "Phone", titulo: "Contacto proactivo", descripcion: "Llamar a los 2.925 pacientes perdidos" },
      { icono: "MessageCircle", titulo: "WhatsApp de seguimiento", descripcion: "Enviar recordatorio de presupuesto pendiente" },
      { icono: "UserCheck", titulo: "Reasignar ejecutivo", descripcion: "Reasignar pacientes incontactables a otro ejecutivo" },
    ],
  },
  {
    id: 3, key: "pabellon", nombre: "Pabellón", icono: "Pill", color: "#F59E0B",
    volumen: 7647, conversion_anterior: 46.5, delta_periodo: null,
    sub_etapas: [
      { nombre: "Pabellón agendado", pacientes: 6765, fuente: "Keiron CRM v2", estado: "REAL" },
      { nombre: "Operado (concretado)", pacientes: 7647, fuente: "Keiron CRM v2", estado: "REAL" },
      { nombre: "Operado en SAP", pacientes: 7195, fuente: "SAP Pabellón", estado: "REAL" },
    ],
    quiebres: [
      { descripcion: "56.2% no operado en 6 meses (9.236)", porcentaje: 56.2, motivo: "Lista espera, rechazo, otro prestador", severidad: "alta" },
    ],
    acciones: [
      { icono: "Calendar", titulo: "Reducir lista de espera", descripcion: "Optimizar agenda de pabellón para reducir tiempos" },
      { icono: "BarChart3", titulo: "Dashboard quirúrgico", descripcion: "Monitoreo en tiempo real de conversión quirúrgica" },
      { icono: "AlertTriangle", titulo: "Alertas de espera", descripcion: "Notificar pacientes con >60 días en lista de espera" },
    ],
  },
];

export const PIPELINE_ONCOLOGICO = [
  {
    id: 1, key: "diagnostico", nombre: "Diagnóstico", icono: "Stethoscope", color: "#EF4444",
    volumen: 2500, conversion_anterior: 100, delta_periodo: null,
    sub_etapas: [
      { nombre: "Diagnóstico oncológico", pacientes: 2500, fuente: "Mock", estado: "MOCK" },
      { nombre: "Hoja de ruta / plan tratamiento", pacientes: 2350, fuente: "Mock", estado: "MOCK" },
    ],
    quiebres: [
      { descripcion: "6% no inicia tratamiento (150 pacientes)", porcentaje: 6.0, motivo: "Paciente rechaza tratamiento", severidad: "media" },
    ],
    acciones: [
      { icono: "MessageCircle", titulo: "Acompañamiento psicológico", descripcion: "Derivar a soporte emocional para pacientes que rechazan" },
      { icono: "Calendar", titulo: "Agendar inicio rápido", descripcion: "Reducir tiempo entre diagnóstico e inicio de tratamiento" },
      { icono: "UserCheck", titulo: "Navegador oncológico", descripcion: "Asignar navegador de paciente para acompañamiento" },
    ],
  },
  {
    id: 2, key: "tratamiento", nombre: "Tratamiento", icono: "Pill", color: "#EC4899",
    volumen: 2200, conversion_anterior: 93.6, delta_periodo: null,
    sub_etapas: [
      { nombre: "Quimio/Radioterapia", pacientes: 2200, fuente: "Mock", estado: "MOCK" },
      { nombre: "Hospitalización (ciclos)", pacientes: 1800, fuente: "Mock", estado: "MOCK" },
      { nombre: "Farmacia oncológica", pacientes: 2200, fuente: "Mock", estado: "MOCK" },
    ],
    quiebres: [
      { descripcion: "18.2% no completa hospitalización", porcentaje: 18.2, motivo: "Abandono de ciclos de tratamiento", severidad: "alta" },
    ],
    acciones: [
      { icono: "Bell", titulo: "Alertas de adherencia", descripcion: "Monitorear asistencia a ciclos de quimioterapia" },
      { icono: "Phone", titulo: "Llamada post-ciclo", descripcion: "Contactar paciente 48h después de cada ciclo" },
      { icono: "Package", titulo: "Farmacia proactiva", descripcion: "Preparar medicamentos antes de la llegada del paciente" },
    ],
  },
  {
    id: 3, key: "seguimiento_onco", nombre: "Seguimiento", icono: "RefreshCw", color: "#D946EF",
    volumen: 2000, conversion_anterior: 90.9, delta_periodo: null,
    sub_etapas: [
      { nombre: "Lab marcadores", pacientes: 2100, fuente: "Mock", estado: "MOCK" },
      { nombre: "Imagen (PET/Scanner)", pacientes: 1900, fuente: "Mock", estado: "MOCK" },
      { nombre: "Control oncológico", pacientes: 2000, fuente: "Mock", estado: "MOCK" },
      { nombre: "Cuestionarios", pacientes: 1600, fuente: "Mock", estado: "MOCK" },
    ],
    quiebres: [
      { descripcion: "27.3% no completa cuestionarios (600)", porcentaje: 27.3, motivo: "Formulario no completado", severidad: "alta" },
      { descripcion: "9.1% imagen de control no agendada", porcentaje: 9.1, motivo: "Imagen de control no agendada", severidad: "media" },
    ],
    acciones: [
      { icono: "FileText", titulo: "Simplificar cuestionarios", descripcion: "Reducir formularios y habilitar llenado digital" },
      { icono: "Calendar", titulo: "Agendar controles automáticos", descripcion: "Crear citas de control al finalizar cada ciclo" },
      { icono: "BarChart3", titulo: "Dashboard oncológico", descripcion: "Panel de seguimiento por paciente oncológico" },
    ],
  },
];

export const PIPELINE_DIALISIS = [
  {
    id: 1, key: "sesiones", nombre: "Sesiones", icono: "Hospital", color: "#D946EF",
    volumen: 258, conversion_anterior: 97.7, delta_periodo: null,
    sub_etapas: [
      { nombre: "Episodio diálisis activo", pacientes: 264, fuente: "etl_dialisis", estado: "REAL" },
      { nombre: "Sesiones hemo/peritoneal", pacientes: 258, fuente: "etl_dialisis", estado: "REAL" },
    ],
    quiebres: [
      { descripcion: "2.3% sin sesión activa (6 pacientes)", porcentaje: 2.3, motivo: "Pacientes sin sesión programada", severidad: "baja" },
    ],
    acciones: [
      { icono: "Calendar", titulo: "Verificar agenda", descripcion: "Revisar pacientes sin sesión programada" },
      { icono: "Bell", titulo: "Alerta de inasistencia", descripcion: "Notificar cuando un paciente falta a sesión" },
      { icono: "Phone", titulo: "Contacto directo", descripcion: "Llamar a pacientes con sesiones pendientes" },
    ],
  },
  {
    id: 2, key: "control_dial", nombre: "Control Clínico", icono: "FlaskConical", color: "#14B8A6",
    volumen: 240, conversion_anterior: 93.0, delta_periodo: null,
    sub_etapas: [
      { nombre: "Lab control (Creat/BUN)", pacientes: 240, fuente: "etl_dialisis", estado: "REAL" },
      { nombre: "Medicamentos (EPO/Hierro)", pacientes: 250, fuente: "etl_dialisis", estado: "REAL" },
    ],
    quiebres: [
      { descripcion: "7% lab atrasado >30 días (18 pacientes)", porcentaje: 7.0, motivo: "Lab de control atrasado", severidad: "media" },
    ],
    acciones: [
      { icono: "Bell", titulo: "Alerta de lab pendiente", descripcion: "Notificar lab de control atrasado >30 días" },
      { icono: "Package", titulo: "Dispensación proactiva", descripcion: "Preparar EPO/Hierro antes de cada sesión" },
      { icono: "BarChart3", titulo: "Dashboard nefrológico", descripcion: "Panel de control por paciente de diálisis" },
    ],
  },
  {
    id: 3, key: "seguimiento_dial", nombre: "Seguimiento", icono: "RefreshCw", color: "#6366F1",
    volumen: 210, conversion_anterior: 81.4, delta_periodo: null,
    sub_etapas: [
      { nombre: "Cuestionarios diálisis", pacientes: 180, fuente: "Mock", estado: "MOCK" },
      { nombre: "Control nefrológico", pacientes: 210, fuente: "Mock", estado: "MOCK" },
    ],
    quiebres: [
      { descripcion: "30.2% cuestionario no completado (78)", porcentaje: 30.2, motivo: "Formulario no completado", severidad: "alta" },
      { descripcion: "12.5% control atrasado >60 días (30)", porcentaje: 12.5, motivo: "Control nefrológico atrasado", severidad: "media" },
    ],
    acciones: [
      { icono: "FileText", titulo: "Digitalizar cuestionarios", descripcion: "Habilitar llenado en tablet durante sesión" },
      { icono: "CalendarCheck", titulo: "Agendar control automático", descripcion: "Crear cita nefrológica al completar ciclo" },
      { icono: "Database", titulo: "Integrar fuentes", descripcion: "Conectar cuestionarios con historia clínica" },
    ],
  },
];

export const PIPELINE_URGENCIA = [
  {
    id: 1, key: "ingreso_urg", nombre: "Ingreso", icono: "Hospital", color: "#F97316",
    volumen: 42000, conversion_anterior: 94.4, delta_periodo: null,
    sub_etapas: [
      { nombre: "Llegada urgencia", pacientes: 45000, fuente: "Mock", estado: "MOCK" },
      { nombre: "Triage", pacientes: 44500, fuente: "Mock", estado: "MOCK" },
      { nombre: "Espera / asignación box", pacientes: 44500, fuente: "Mock", estado: "MOCK" },
      { nombre: "Atención médica", pacientes: 42000, fuente: "Mock", estado: "MOCK" },
    ],
    quiebres: [
      { descripcion: "5.6% se fue sin ser atendido (2.500)", porcentaje: 5.6, motivo: "Espera excesiva", severidad: "alta" },
    ],
    acciones: [
      { icono: "Clock", titulo: "Reducir tiempo de espera", descripcion: "Optimizar flujo de triage y asignación de box" },
      { icono: "Users", titulo: "Refuerzo en peak", descripcion: "Aumentar dotación en horarios de mayor demanda" },
      { icono: "Monitor", titulo: "Panel de espera", descripcion: "Pantalla en sala de espera con tiempos estimados" },
    ],
  },
  {
    id: 2, key: "resolucion_urg", nombre: "Resolución", icono: "FlaskConical", color: "#06B6D4",
    volumen: 36000, conversion_anterior: 85.7, delta_periodo: null,
    sub_etapas: [
      { nombre: "Indicaciones urgencia", pacientes: 38000, fuente: "Mock", estado: "MOCK" },
      { nombre: "Lab/Imagen urgencia", pacientes: 25000, fuente: "Mock", estado: "MOCK" },
      { nombre: "Farmacia urgencia", pacientes: 30000, fuente: "Mock", estado: "MOCK" },
      { nombre: "Alta", pacientes: 36000, fuente: "Mock", estado: "MOCK" },
    ],
    quiebres: [
      { descripcion: "34.2% lab/imagen no realizado en urgencia", porcentaje: 34.2, motivo: "Indicación no ejecutada durante la atención", severidad: "media" },
    ],
    acciones: [
      { icono: "Bell", titulo: "Alerta de indicaciones", descripcion: "Notificar indicaciones pendientes antes del alta" },
      { icono: "Package", titulo: "Farmacia express", descripcion: "Dispensación rápida para pacientes de urgencia" },
      { icono: "FileText", titulo: "Checklist de alta", descripcion: "Verificar que todas las indicaciones se completaron" },
    ],
  },
  {
    id: 3, key: "post_urg", nombre: "Post-Urgencia", icono: "RefreshCw", color: "#F43F5E",
    volumen: 5400, conversion_anterior: 15.0, delta_periodo: null,
    sub_etapas: [
      { nombre: "Hospitalización (desde urg)", pacientes: 6000, fuente: "Mock", estado: "MOCK" },
      { nombre: "Encuesta post-urgencia", pacientes: 9000, fuente: "Mock", estado: "MOCK" },
      { nombre: "Control post-urgencia", pacientes: 5400, fuente: "Mock", estado: "MOCK" },
    ],
    quiebres: [
      { descripcion: "85% no volvió a control post-urgencia (30.600)", porcentaje: 85.0, motivo: "No volvió al control", severidad: "alta" },
      { descripcion: "75% sin feedback del paciente (27.000)", porcentaje: 75.0, motivo: "Sin encuesta respondida", severidad: "alta" },
    ],
    acciones: [
      { icono: "CalendarCheck", titulo: "Agendar control al alta", descripcion: "Crear cita de control automáticamente al dar de alta" },
      { icono: "MessageSquare", titulo: "Encuesta por WhatsApp", descripcion: "Enviar encuesta NPS dentro de 24h post-alta" },
      { icono: "Phone", titulo: "Llamada de seguimiento", descripcion: "Contactar paciente 72h después del alta" },
    ],
  },
];

// ============================================================
// Pipeline COBRANZAS — Datos REALES de ciclo_ingresos (Oct 2025)
// Fuente: Redshift ciclo_ingresos.ar_camadas_tot_monto
// ============================================================

export const PIPELINE_COBRANZAS = [
  {
    id: 1, key: "facturacion", nombre: "Facturación", icono: "DollarSign", color: "#7C3AED",
    volumen: 158372, conversion_anterior: 100, delta_periodo: null,
    sub_etapas: [
      { nombre: "Episodios facturados", pacientes: 158372, fuente: "ciclo_ingresos.ar_camadas_tot_monto", estado: "REAL" },
      { nombre: "Monto total camada", pacientes: null, fuente: "Oct 2025: $105.834 MM CLP", estado: "REAL" },
    ],
    quiebres: [
      { descripcion: "FONASA Libre Elección concentra $19.677 MM (18.6% del total)", porcentaje: 18.6, motivo: "Mayor volumen de facturación por convenio", severidad: "media" },
      { descripcion: "Ley Urgencia FONASA: $5.764 MM con solo 744 episodios", porcentaje: 5.4, motivo: "Alto monto promedio por episodio de urgencia vital", severidad: "alta" },
      { descripcion: "Paciente Privado: $4.639 MM — 84.8% vigente (buen cobro)", porcentaje: 4.4, motivo: "Alta tasa de cobro en pacientes privados", severidad: "baja" },
    ],
    acciones: [
      { icono: "BarChart3", titulo: "Dashboard de facturación", descripcion: "Monitoreo en tiempo real de facturación por convenio y centro" },
      { icono: "FileText", titulo: "Auditar facturación GES", descripcion: "Revisar episodios GES con montos altos sin cobertura" },
      { icono: "AlertTriangle", titulo: "Alertas de facturación", descripcion: "Notificar episodios con monto > $10 MM sin cobertura asignada" },
    ],
  },
  {
    id: 2, key: "vigente", nombre: "Cartera Vigente", icono: "CreditCard", color: "#10B981",
    volumen: 29563, conversion_anterior: 27.9, delta_periodo: null,
    sub_etapas: [
      { nombre: "Vigente 0-30 días", pacientes: null, fuente: "$29.563 MM CLP", estado: "REAL" },
      { nombre: "FONASA Libre Elección", pacientes: null, fuente: "$10.235 MM (34.6%)", estado: "REAL" },
      { nombre: "Paciente Privado", pacientes: null, fuente: "$3.933 MM (13.3%)", estado: "REAL" },
      { nombre: "Colmena Libre Elección", pacientes: null, fuente: "$3.359 MM (11.4%)", estado: "REAL" },
    ],
    quiebres: [
      { descripcion: "Solo 27.9% de la cartera está vigente (0-30 días)", porcentaje: 27.9, motivo: "72.1% de la cartera tiene más de 30 días", severidad: "alta" },
      { descripcion: "FONASA concentra 34.6% de la cartera vigente", porcentaje: 34.6, motivo: "Mayor volumen de cobro pendiente en FONASA", severidad: "media" },
    ],
    acciones: [
      { icono: "Clock", titulo: "Acelerar cobro vigente", descripcion: "Priorizar cobro de cartera 0-30 días antes de que envejezca" },
      { icono: "Phone", titulo: "Contacto proactivo FONASA", descripcion: "Gestionar cobro de $10.235 MM FONASA vigente" },
      { icono: "CreditCard", titulo: "Facilitar pago", descripcion: "Ofrecer planes de pago para cartera vigente de alto monto" },
    ],
  },
  {
    id: 3, key: "mora_temprana", nombre: "Mora Temprana", icono: "AlertTriangle", color: "#F59E0B",
    volumen: 42, conversion_anterior: 0.04, delta_periodo: null,
    sub_etapas: [
      { nombre: "Mora 31-60 días", pacientes: null, fuente: "$42 MM CLP", estado: "REAL" },
      { nombre: "Tendencia mensual", pacientes: null, fuente: "Ene: $11.905 MM → Oct: $42 MM (mejora)", estado: "REAL" },
    ],
    quiebres: [
      { descripcion: "Mora 31-60 días bajó de $11.905 MM (Ene) a $42 MM (Oct)", porcentaje: null, motivo: "Mejora significativa en gestión de cobro temprano", severidad: "baja" },
    ],
    acciones: [
      { icono: "Bell", titulo: "Alertas de mora temprana", descripcion: "Notificar cuentas que pasan de 30 a 31 días" },
      { icono: "MessageCircle", titulo: "Recordatorio automático", descripcion: "Enviar recordatorio de pago al día 31" },
      { icono: "BarChart3", titulo: "Monitorear tendencia", descripcion: "Mantener la tendencia de reducción de mora temprana" },
    ],
  },
  {
    id: 4, key: "mora_avanzada", nombre: "Mora Avanzada", icono: "XCircle", color: "#EF4444",
    volumen: 0, conversion_anterior: 0, delta_periodo: null,
    sub_etapas: [
      { nombre: "Mora 61-180 días", pacientes: null, fuente: "$0 MM (Oct 2025)", estado: "REAL" },
      { nombre: "Mora 181-360 días", pacientes: null, fuente: "$0 MM (Oct 2025)", estado: "REAL" },
      { nombre: "Mora >360 días", pacientes: null, fuente: "$0 MM (Oct 2025)", estado: "REAL" },
      { nombre: "Nota: meses anteriores sí tenían mora avanzada", pacientes: null, fuente: "Ene: $37.449 MM en 60-180 días", estado: "REAL" },
    ],
    quiebres: [
      { descripcion: "Mora avanzada eliminada en Oct 2025 (era $37.449 MM en Ene)", porcentaje: null, motivo: "Gestión exitosa de cartera vencida o reclasificación", severidad: "baja" },
      { descripcion: "Verificar si es gestión real o reclasificación contable", porcentaje: null, motivo: "La caída abrupta puede indicar castigo o ajuste", severidad: "media" },
    ],
    acciones: [
      { icono: "Search", titulo: "Investigar reducción", descripcion: "Verificar si la mora avanzada fue cobrada, castigada o reclasificada" },
      { icono: "Database", titulo: "Cruzar con castigados", descripcion: "Comparar con ar_camadas_castigados para entender el destino" },
      { icono: "FileText", titulo: "Informe de gestión", descripcion: "Documentar la evolución de mora avanzada Ene→Oct 2025" },
    ],
  },
  {
    id: 5, key: "recuperaciones", nombre: "Recuperaciones", icono: "RefreshCw", color: "#3B82F6",
    volumen: 124368, conversion_anterior: null, delta_periodo: null,
    sub_etapas: [
      { nombre: "Total recuperado 2025", pacientes: null, fuente: "$496.988 MM CLP (124.368 registros)", estado: "REAL" },
      { nombre: "Promedio mensual", pacientes: null, fuente: "~$49.699 MM/mes", estado: "REAL" },
      { nombre: "Tendencia vs 2024", pacientes: null, fuente: "2024: $545.323 MM → 2025: $496.988 MM (-8.9%)", estado: "REAL" },
    ],
    quiebres: [
      { descripcion: "Recuperaciones 2025 caen 8.9% vs 2024 ($545.323 MM → $496.988 MM)", porcentaje: 8.9, motivo: "Menor recuperación interanual", severidad: "alta" },
      { descripcion: "Top convenio: FONASA Libre Elección (mayor volumen de recuperación)", porcentaje: null, motivo: "Concentración de recuperación en FONASA", severidad: "media" },
    ],
    acciones: [
      { icono: "TrendingUp", titulo: "Plan de recuperación", descripcion: "Definir meta de recuperación para cerrar brecha vs 2024" },
      { icono: "Users", titulo: "Reforzar equipo", descripcion: "Aumentar capacidad de gestión de cobranza para ISAPRE" },
      { icono: "Phone", titulo: "Campaña de cobro", descripcion: "Campaña masiva de cobro para cartera >90 días" },
    ],
  },
];

// Mapa de pipelines por tipo de viaje
export const PIPELINES_BY_TYPE = {
  ambulatorio: PIPELINE_STAGES,
  hospitalario: PIPELINE_HOSPITALARIO,
  oncologico: PIPELINE_ONCOLOGICO,
  dialisis: PIPELINE_DIALISIS,
  urgencia: PIPELINE_URGENCIA,
  cobranzas: PIPELINE_COBRANZAS,
};

// Transiciones por tipo de viaje
export const TRANSICIONES_BY_TYPE = {
  ambulatorio: PIPELINE_TRANSICIONES,
  hospitalario: [
    { desde: "Indicación", hacia: "CRM", perdidos: 332, pct_perdida: 2.0 },
    { desde: "CRM", hacia: "Pabellón", perdidos: 8452, pct_perdida: 52.5 },
  ],
  oncologico: [
    { desde: "Diagnóstico", hacia: "Tratamiento", perdidos: 300, pct_perdida: 12.0 },
    { desde: "Tratamiento", hacia: "Seguimiento", perdidos: 200, pct_perdida: 9.1 },
  ],
  dialisis: [
    { desde: "Sesiones", hacia: "Control", perdidos: 18, pct_perdida: 7.0 },
    { desde: "Control", hacia: "Seguimiento", perdidos: 30, pct_perdida: 12.5 },
  ],
  urgencia: [
    { desde: "Ingreso", hacia: "Resolución", perdidos: 6000, pct_perdida: 14.3 },
    { desde: "Resolución", hacia: "Post-Urgencia", perdidos: 30600, pct_perdida: 85.0 },
  ],
  cobranzas: [
    { desde: "Facturación", hacia: "Vigente", perdidos: 76271, pct_perdida: 72.1 },
    { desde: "Vigente", hacia: "Mora Temprana", perdidos: 29521, pct_perdida: 99.9 },
    { desde: "Mora Temprana", hacia: "Recuperaciones", perdidos: null, pct_perdida: null },
  ],
};
